import * as React from "react";
const SvgFiBrandsCreativeCommons = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-creative-commons_svg__a)">
      <path
        fill="#151A2D"
        d="M11.979 0c5.404 0 10.519 3.906 11.719 9.225.205.91.302 1.843.302 2.775q0 2.464-.868 4.618C21.354 21.03 16.699 24 11.979 24 6.145 24 1.047 19.528.141 13.791A11.5 11.5 0 0 1 0 12C0 6.212 4.33 1.109 10.032.161A12 12 0 0 1 11.979 0m.042 2.164c-5.289 0-9.857 4.541-9.857 9.836 0 5.279 4.611 9.793 9.857 9.793 5.35 0 9.814-4.458 9.814-9.793.001-5.368-4.442-9.836-9.814-9.836m-.15 7.843-1.607.836q-.257-.535-.632-.75t-.696-.214q-1.607 0-1.607 2.121 0 .964.407 1.543t1.2.579q1.05 0 1.479-1.029l1.479.75a3.5 3.5 0 0 1-1.307 1.382 3.5 3.5 0 0 1-1.843.504q-1.607 0-2.593-.986-.987-.985-.987-2.743 0-1.714.997-2.722.996-1.007 2.518-1.007 2.228.001 3.192 1.736m6.922 0-1.586.836q-.257-.535-.632-.75a1.45 1.45 0 0 0-.718-.214q-1.607 0-1.607 2.121 0 .964.407 1.543t1.2.579q1.05 0 1.479-1.029l1.5.75a3.7 3.7 0 0 1-1.329 1.382 3.46 3.46 0 0 1-1.821.504q-1.63 0-2.603-.986-.975-.985-.975-2.743 0-1.714.996-2.722.996-1.007 2.518-1.007 2.227.001 3.171 1.736"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommons;
